import permissionsHelper         from "../utils/permissionsHelper"
import {GUEST_SERVER_PERMISSION} from '@/config/permissions'
import {notReactiveState}        from "./state"

export default {
  isCacheExpire: (state) => (payload) => {
    let {endpoint = null} = payload;
    const now = Date.now();
    return !(state.cache[endpoint] && state.cache[endpoint] > now);
  },
  breadcrumbs: (state) => (name) => {
    if (state.breadcrumbs[name]) {
      return state.breadcrumbs[name];
    }
    return null
  },
  userCan: (state, getters) => (name, options = {}) => {
    let {route = {}} = options;
    // check perms in router config
    if (route?.meta?.havePerms?.indexOf(name) > -1) {
      return true;
    }
    let found = null;
    
    let matched = route.matched || [route];
    if (matched) {
      for (let i = matched.length; i > -1; i--) {
        if (matched?.[i]?.name) {
          found = permissionsHelper.findModulePermission(matched[i].name, name);
        }
        if (found) {
          break;
        }
      }
    }
    // get user perm
    const userData = getters.userData || {perms: GUEST_SERVER_PERMISSION};
    if (found !== null && userData?.perms?.indexOf(found) > -1) {
      // if edit card opened for view
      return !(route?.name?.endsWith('.view') && (name === 'delete' || name === 'edit'));
    }
    return !!((matched?.[0]?.title?.indexOf('Текстовые материалы') > -1 ||
      matched?.[0]?.name?.indexOf('verstka') > -1 ||
      matched?.[0]?.name?.indexOf('development') > -1));
    
  },
  formState: (state) => (name, param) => {
    if (state.forms.hasOwnProperty(param) && state.forms[param].hasOwnProperty(name)) {
      return state.forms[param][name]
    }
    return null
  },
  skipAsyncData: (state) => (name) => {
    return state.skipAsyncData[name]
  },
  tableState: (state) => (id, param) => {
    if (state.tables[param] && state.tables[param][id]) {
      return state.tables[param][id]
    }
    return null
  },
  readUrlEndpoint: (state) => (endpoint) => {
    if (state.endpoints[endpoint]) {
      return state.endpoints[endpoint]
    }
    if (notReactiveState.endpoints[endpoint]) {
      return notReactiveState.endpoints[endpoint]
    }
    return null
  },
  userData: state => {
    return state._userData
  },
  authToken: state => {
    if (state._userData !== null) {
      return state._userData.access_token
    } else {
      return null
    }
  },
  isGuest: (state, getters) => {
    if (!getters.authToken) {
      return true
    }
    if (state._userData === null) {
      return true
    }
    return false
  },
  redirectUrl: state => {
    return state._redirectUrl
  },
  needReLogin: state => {
    return state._needReLogin
  },
  getError: state => {
    return state._error
  },
  charts: state => {
    return state.charts
  },
  preloader: state => state.preloader,
  preloaderOn: state => state.preloaderOn,
  isPreloadStart: state => state.preloaderLoad > 0
}
